import jQuery from 'jquery';
import WOW from 'wow.js';

import './libs/foundation';

import ContentCards from './components/content-cards';
import Filters from './components/filters';
import Gallery from './components/gallery';
import Infographic from './components/infographic';
import LogoSlider from './components/logo-slider';
import MultiCopyBlock from './components/multi-copy-block';
import OffCanvas from './components/off-canvas';
import StatsBlock from './components/stats-block';
import Video from './components/video';

jQuery($ => {
    let contentCards = new ContentCards();
    let filters = new Filters();
    let gallery = new Gallery();
    let infographic = new Infographic();
    let logoSlider = new LogoSlider();
    let multiCopyBlock = new MultiCopyBlock();
    let offCanvas = new OffCanvas();
    let statsBlock = new StatsBlock();
    let video = new Video();
});

var wow = new WOW({
    resetAnimation: false
});
wow.init();
